<div class="model d-flex flex-column align-items-center justify-content-center">
    <div class="modal__logo mt-2">
        <img src="assets/img/logo1.png" alt="" height="35" class="w-80">
    </div>
    <h2 class="modal__title text-center mt-2">We've updated <strong style="font-weight: bold;">Nextere</strong></h2>
    <p class="modal__message text-center mt-2" style="font-size: 20px;">
        To get the latest version of <span style="color: #746a6a;">Nextere</span>, Refresh your page.
    </p>
    <button class="btn btn-primary mt-2" (click)="refreshPage()">Refresh</button>
</div>